import { render, staticRenderFns } from "./FullENSForm.vue?vue&type=template&id=250a3c08&"
import script from "./FullENSForm.vue?vue&type=script&lang=js&"
export * from "./FullENSForm.vue?vue&type=script&lang=js&"
import style0 from "./FullENSForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports